export const StatusTypes = {
  uptime: "Running",
  standBy: "Standby",
  maintenance: "Maintenance",
  failure: "Failure"
};

const TIMETYPES = [
  ["hour", 3600],
  ["minute", 60],
  ["seconds", 1]
];

export const loadingResponse = {
  status: "Loading",
  totalTime: timeFormat(0),
  meanTime: timeFormat(0 / 1)
};

function timeFormat(miliseconds) {
  const seconds = miliseconds / 1000;

  for (const [unit, value] of TIMETYPES) {
    if (seconds > value || unit === "seconds") {
      const response = {
        time: parseFloat((seconds / +value).toFixed(2)),
        unit: unit
      };
      return response;
    }
  }
  return null;
}

export function convertDate(firebaseObject) {
  if (
    Object.prototype.hasOwnProperty.call(firebaseObject, "seconds") &&
    Object.prototype.hasOwnProperty.call(firebaseObject, "nanoseconds")
  ) {
    const date = new Date(
      firebaseObject.seconds * 1000 + firebaseObject.nanoseconds * 10000000
    );
    return date;
  }
  return new Date(firebaseObject);
}

export class StatusChange {
  constructor(status, changeDate) {
    this.date = changeDate;
    this.status = status;
  }
}

export class StatusList {
  constructor(list) {
    this.list = list;
  }
  totalTime(status) {
    let totalTime = 0;
    const listLength = this.list.length;
    this.list.forEach((elem, index) => {
      if (elem.status === status) {
        if (index !== listLength - 1) {
          totalTime += +this.list[index + 1].date - +elem.date;
        } else {
          totalTime += Math.abs(+Date.now() - +elem.date);
        }
      }
    });
    return totalTime;
  }
  timeFormat(miliseconds) {
    return timeFormat(miliseconds);
  }
  meanTime(status) {
    const totalTime = this.totalTime(status);
    let statusTimes = 0;
    this.list.forEach(elem => {
      if (elem.status === status) {
        statusTimes += 1;
      }
    });
    const response = {
      status,
      totalTime,
      totalTimeInHours: totalTime / (1000 * 3600),
      meanTime: totalTime / statusTimes,
      meanTimeInHours: totalTime / statusTimes / (1000 * 3600)
    };
    // console.log(`Mean time in ${status}:`, timeFormat(totalTime / statusTimes));
    return response;
  }
  interval(dates) {
    const dateA =
      new Date(dates[0]) < new Date(dates[1])
        ? new Date(dates[0])
        : new Date(dates[1]);
    const dateB =
      new Date(dates[0]) > new Date(dates[1])
        ? new Date(dates[0])
        : new Date(dates[1]);
    const startDate =
      dateA > Date.now()
        ? Date.now()
        : dateA < this.list[0].date
        ? +this.list[0].date
        : dateA;
    const finishDate = dateB < Date.now() ? dateB : Date.now();

    return finishDate - startDate;
  }
  recalculate(status, dates) {
    const dateA =
      new Date(dates[0]) < new Date(dates[1])
        ? new Date(dates[0])
        : new Date(dates[1]);
    const dateB =
      new Date(dates[0]) > new Date(dates[1])
        ? new Date(dates[0])
        : new Date(dates[1]);
    const startDate = dateA < Date.now() ? dateA : Date.now();
    const finishDate = dateB < Date.now() ? dateB : Date.now();

    let count = 0;
    let totalTime = 0;
    const listLength = this.list.length;

    //console.log(status, ":");

    this.list.forEach((elem, index) => {
      if (+elem.date > startDate && +elem.date < finishDate) {
        if (count === 0) {
          // * Que este antes del primero de la lista
          if (elem.status === status && index === 0) {
            if (this.list[index + 1].date > finishDate) {
              /* console.log("Caso 1");
              console.log(timeFormat(finishDate - +elem.date)); */
              totalTime += finishDate - +elem.date;
            } else {
              /* console.log("Caso 2");
              console.log(timeFormat(this.list[index + 1].date - +elem.date)); */
              totalTime += this.list[index + 1].date - +elem.date;
            }
            count += 1;
          }
          // * Que este despues del primero y que es primero sea del status
          if (index !== 0 && this.list[index - 1].status === status) {
            /* console.log("Caso 3");
            console.log(timeFormat(+elem.date - startDate)); */
            totalTime += +elem.date - startDate;
            count += 1;
          }
          // * Que este despues del primer y que el siguiente sea del status
          if (index !== 0 && elem.status === status) {
            if (this.list[index + 1]) {
              if (this.list[index + 1].date > finishDate) {
                /* console.log("Caso 4");
                console.log(timeFormat(finishDate - +elem.date)); */
                totalTime += finishDate - +elem.date;
              } else {
                /* console.log("Caso 5");
                console.log(timeFormat(this.list[index + 1].date - +elem.date)); */
                totalTime += this.list[index + 1].date - +elem.date;
              }
            } else {
              /* console.log("Caso 6");
              console.log(timeFormat(finishDate - +elem.date)); */
              totalTime += finishDate - +elem.date;
            }
            count += 1;
          }
        } else {
          if (elem.status === status) {
            if (
              this.list[index + 1] &&
              this.list[index + 1].date < finishDate
            ) {
              /* console.log("Caso 7");
              console.log(timeFormat(this.list[index + 1].date - +elem.date)); */
              totalTime += this.list[index + 1].date - +elem.date;
            } else {
              /* console.log("Caso 8");
              console.log(timeFormat(finishDate - +elem.date)); */
              totalTime += finishDate - +elem.date;
            }
          }
        }
      }
    });

    if (totalTime === 0) {
      if (
        this.list[listLength - 1].date < startDate &&
        this.list[listLength - 1].status === status
      ) {
        totalTime += finishDate - startDate;
        /* console.log("Caso 9");
        console.log(timeFormat(finishDate - startDate)); */
      }
    }
    return totalTime;
  }

  recalculatePercentage(status, dates) {
    const totalTimeInStatus = this.recalculate(status, dates);
    const totalTime = this.interval(dates);

    return (totalTimeInStatus / totalTime) * 100;
  }
}
